var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoutesIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33309 18.7614L0.5 17.3396V7.18657L5.33309 8.60947V18.7614Z",
    fill: "#6A6A99",
    stroke: "#6A6A99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6851 13.8361H12.0051L12.005 17.551L7.17188 18.7958V9.45583C8.38669 11.7422 10.3439 13.2611 10.652 13.4908L10.6533 13.4918C10.9497 13.7113 11.3073 13.8361 11.6851 13.8361Z",
    fill: "#6A6A99",
    stroke: "#6A6A99"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5027 8.85994V19.0146L13.8359 17.5541V12.5237C14.7875 11.6072 16.1054 10.0776 16.7623 8.15306L19.4491 8.84542L19.451 8.84713L19.5027 8.85994Z",
    fill: "#6A6A99",
    stroke: "#6A6A99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12C13 12 16 7.20914 16 5C16 2.79086 14.2091 1 12 1C9.79086 1 8 2.79086 8 5C8 7.20914 11 12 12 12ZM12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7Z",
    fill: "#6A6A99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutesIcon);
export default __webpack_public_path__ + "static/media/RoutesIcon.34c6f7bde6c3641be1eb7aa9221dbbd0.svg";
export { ForwardRef as ReactComponent };